import React, { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("seo-metadata-root");

if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <App {...window.__seo_metadata_initial_state__} />
    </StrictMode>,
  );
}
